import { NgModule } from '@angular/core';
import { SharedModule } from '@app-shared/shared.module';
import { GeotabPageNotAccessibleComponent } from './components/geotab-page-not-accessible/geotab-page-not-accessible.component';
import { GeotabRoutingModule } from './geotab-routing.module';

@NgModule({
  declarations: [GeotabPageNotAccessibleComponent],
  imports: [GeotabRoutingModule, SharedModule],
})
export class GeotabModule {}
